module.exports = __webpack_public_path__ + "static/img/logo-goship-gosell.dd63efe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/authorization/logo-goship-gosell.png
// module id = yVL4
// module chunks = 134